module.exports = __webpack_public_path__ + "static/media/Alerts.d0c7533d.svg";